// extracted by mini-css-extract-plugin
module.exports = {"howItWorks":"HowItWorks_howItWorks__3VT6x"};